module.exports = __webpack_public_path__ + "media/images/bow-pikka-b3f40fda4687e5a6a929322e84bbdbc9.jpg";